// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { productBoxesStyle } from "@steiner/App/Components/Product/ProductBoxes";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productBoxesStyle.datatable = {
    css: css`
        border: 1px solid ${color("common.border")};
        width: auto;
        margin-top: 8px;
    `,
};

productBoxesStyle.qtyInput = {
    cssOverrides: {
        formField: css`
            width: 36px;
        `,
        inputSelect: css`
            padding: 4px;
            text-align: center;
            height: 26px;
        `,
    },
};

productBoxesStyle.addToCartButton = {
    css: css`
        min-height: 26px;
        width: 42px;
        padding: 6px 12px;
        text-align: center;
        ${IconWrapper} {
            color: ${color("text.main")};
            margin-left: 0;
        }
    `,
};

productBoxesStyle.qtyCell = {
    css: css`
        padding-left: 0;
        padding-right: 0;
        height: 52px;
        ${xScreen("lte", "xs")} {
            height: 50px;
        }
    `,
};

productBoxesStyle.addToCartCell = {
    css: css`
        padding-left: 12px;
        padding-right: 12px;
        height: 52px;
        ${xScreen("lte", "xs")} {
            height: 50px;
        }
    `,
};

productBoxesStyle.labelCell = {
    typographyProps: {
        weight: fontConfig.weight.semiBold,
    },
    css: css`
        padding-left: 12px;
        padding-right: 12px;
        width: 115px;
        height: 52px;
        ${xScreen("lte", "xs")} {
            height: 50px;
        }
    `,
};

productBoxesStyle.addToCartButton = {
    sizeVariant: "small",
};
